import type OLLayerVector from 'ol/layer/Vector'
import type Style from 'ol/style/Style'

import type { ConfigLayerOptions } from 'config/ConfigLayer'
import PoziConfigGeoJSON from 'config/geojson'
import { MapLayer } from 'config/MapLayer'

export interface MapLayerGeoJsonLegacyStyleOptions {
  style2?: Style
  backgroundBubble2?: Style
  shadow?: Style
  pointStyle: ((feature: any, resolution: any) => any[] | undefined) | null
  pointSelectedStyle: (feature: any, resolution: any) => any[] | undefined
  olLayer: OLLayerVector
}

export class MapLayerGeoJson extends MapLayer {
  static createLayer(layerConf: ConfigLayerOptions): OLLayerVector | undefined {
    this.preLayer(layerConf)

    return PoziConfigGeoJSON().getGeoJSONLayer(layerConf)
  }
}
